<template>
  <div class="">
    <!--管理页面 搜索框及搜索相关按键 -->
      <div id="searchInput" class="in_row search_box flex flex-wrap align-items marginBottom20">
          <div class="search_input in_column " v-for="(item, index) in searchList" :key="index">
              <span v-if="item.searchShow" class="flex align-items marginRight10 marginBottom10">
                <span class="text_label span marginRight10 width80 textAlignRight">{{ item.label }}</span>
                <!-- 输入框 -->
                <el-input class="width300" v-if="item.type === 'text'" v-model="searchData[item.prop]" :placeholder="`请输入${item.label}`" clearable @keyup.enter="handleSearch()" />
                <!-- 下拉选择框 -->
                <el-select class="width300" v-if="item.type === 'select'" v-model="searchData[item.prop]" :placeholder="`请选择${item.label}`" clearable>
                    <el-option
                      v-for="item in item.options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>
              <!-- 日期选择 -->
              <el-date-picker class="width300" v-if="item.type == 'date'" v-model="searchData[item.prop]" type="date"
              placeholder="请选择日期" :editable="false" />
              <el-date-picker class="width300" v-if="item.type == 'daterange'" v-model="searchData[item.prop]" type="daterange"  range-separator="至" start-placeholder="请选择开始日期" end-placeholder="请选择结束日期" :editable="false"   format="yyyy-MM-dd" />
              </span>
          </div>
          <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
              class="marginLeft10">搜索</el-button>
            <el-button size="medium" type="info" @click="handleReset" style="margin-bottom: 10px"
              class="marginLeft10">重置</el-button>
            <el-button size="medium"  id="addBtn" style="margin-bottom: 10px"  class="marginLeft10" v-if="needAdd" type="success" @click="add()">
                <el-icon class="icon_inner" ><CirclePlus /></el-icon>新增
            </el-button>
            <el-button size="medium" id="deleteBtn" style="margin-bottom: 10px"  class="marginLeft10" type='danger' @click="del()" :disabled="selectIds.length === 0">
              <el-icon class="icon_inner"><Delete /></el-icon>删除
            </el-button>
      </div>
    </div>
</template>

<script>
import { formatLocalDate } from '@/utils/manageHandler'

export default {
  name: 'SearchBox',
  emits: ['search', 'add', 'del', 'reset'],
  props: {
    // 是否显示新增按钮
    needAdd: {
      type: Boolean,
      default: true
    },
    // 搜索框列表
    searchList: {
      type: Array,
      required: true
    },
    // 勾选的ids集合
    selectIds: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  data () {
    return {
      // 搜索框数据
      searchData: {}
    }
  },
  methods: {
    //  点击搜索
    handleSearch () {
      const rawObject = this.searchData.__v_raw || this.searchData
      // 打印的日期请转换成标准的年月日格式 （如  2025-05-28）
      if (rawObject.updateTime) {
        this.searchData.startTime = formatLocalDate(rawObject.updateTime[0])
        this.searchData.endTime = formatLocalDate(rawObject.updateTime[1])
      }
      this.$emit('search', this.searchData)
    },
    // 点击重置
    handleReset () {
      // 清空搜索框数据
      this.searchData = {}
      // 重置表格数据
      this.$emit('reset')
    },
    // 点击新增
    add () {
      this.$emit('add')
    },
    // 点击删除
    del () {
      this.$emit('del')
    }
  }
}
</script>

<style>
</style>
